import { z } from "zod";

export const EventDocumentationPublished = z.object({
  type: z.literal("DocumentationPublished"),
  workspaceId: z.string(),
  designSystemId: z.string(),
  versionId: z.string(),
});

export type EventDocumentationPublished = z.infer<typeof EventDocumentationPublished>;
